// src/utils/isTokenValid.js
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

const isTokenValid = () => {
  const token = Cookies.get("jwt");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    if (decoded.exp * 1000 < Date.now()) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export default isTokenValid;
